/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 *
 */

let baseUrl = ''
let resUrl = ''
let specificationUrl = ''
let uploadUrl=''
if (process.env.NODE_ENV === 'development') {
  // baseUrl = 'http://192.168.8.61:18080';
  // baseUrl = 'http://develop.gooddrug.com.cn:21025';
  baseUrl = 'http://localhost:18080';
  // baseUrl = 'http://cch.gooddrug.com.cn:18082';
  // resUrl = 'http://res.gooddrug.com.cn:9503';
  resUrl = 'https://res.gooddrug.cn:8714';
  specificationUrl = 'https://rest.gooddrug.cn:8714'; // 说明书
} else if (process.env.NODE_ENV === 'production') {
  baseUrl = 'https://cch.gooddrug.cn:18082';
  resUrl = 'https://res.gooddrug.cn:8714';
  specificationUrl = 'https://rest.gooddrug.cn:8714'; // 说明书
}
export {
  baseUrl,
  resUrl,
  specificationUrl,
  uploadUrl
}
